import type { AppTranslateFn } from "@/hooks/use-app-translation";
import type { AdminFormI18nPaths } from "../../admin-form-editor-i18n-paths";
import {
	PALETTE_FIELD_DEFAULT_LABELS,
	paletteFieldTypeToI18nKey,
} from "../../lib/palette-metadata";
import type { PaletteFieldType } from "../../types";

export function translatePaletteFieldTypeLabel(
	t: AppTranslateFn,
	paths: AdminFormI18nPaths,
	fieldType: PaletteFieldType,
): string {
	const key = paletteFieldTypeToI18nKey(fieldType);
	const path =
		paths.formEditor.palette.types[
			key as keyof typeof paths.formEditor.palette.types
		];
	const translated = String(t(path) ?? "");
	if (translated === "" || translated === path) {
		return PALETTE_FIELD_DEFAULT_LABELS[fieldType];
	}
	return translated;
}
